import { useRecoilValue } from 'recoil';

import DialogContent from '@mui/material/DialogContent';
import { styled } from '@mui/material/styles';

import ModalityViewer from 'src/components/Viewer/ModalityViewer';
import { contoursByShapeState } from 'src/states/annotation';
import { caseState } from 'src/states/case';
import { Modality } from 'src/types/api/data/image';

import CommonDialog, { CommonDialogProps } from './CommonDialog';

export interface JobDialogProps extends CommonDialogProps {
  jobId: string;
  caseId: string;
  modality: Modality;
}

export default function ViewJobDialog({
  open,
  onClose = () => {},
  jobId,
  caseId,
  modality,
}: JobDialogProps): JSX.Element {
  const caseSchema = useRecoilValue(
    caseState.caseSchema({
      caseId,
      modality,
    })
  );
  const caseImages = caseSchema?.images;

  const contoursByShape = useRecoilValue(
    contoursByShapeState({ jobId, modality })
  );

  return (
    <CommonDialog
      onClose={onClose}
      aria-labelledby="view-job-and-annotation"
      open={open}
      title="View Job"
    >
      <DialogContent>
        <ViewerContainer>
          <ModalityViewer
            modalityLabel={modality}
            images={caseImages}
            contoursByShape={contoursByShape}
          />
        </ViewerContainer>
      </DialogContent>
    </CommonDialog>
  );
}

const ViewerContainer = styled('div')`
  width: 500px;
`;
